import { render, staticRenderFns } from "./followModal.vue?vue&type=template&id=67a493b7&"
import script from "./followModal.vue?vue&type=script&lang=js&"
export * from "./followModal.vue?vue&type=script&lang=js&"
import style0 from "./followModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports